<mat-expansion-panel>
    <mat-expansion-panel-header>
        <mat-panel-title>
            <div class="row gap-8 align-center">
                <img
                    *ngIf="category.image"
                    class="image-icon"
                    [src]="
                        frontendurl +
                        '/public/catimages/thumbs/' +
                        category.image
                    "
                />
                <rr-badge>{{ category.status }}</rr-badge>
                <div>
                    {{ category.name }}
                </div>
            </div>
        </mat-panel-title>

        <mat-panel-description class="panel-description">
            <div class="info-row">
                <div class="category-actions">
                    <rr-icon
                        name="add"
                        (click)="showCreateCategory.emit(category.id)"
                    ></rr-icon>
                    <rr-icon
                        name="edit"
                        (click)="editCategory.emit(category)"
                        class="edit"
                    ></rr-icon>
                    <rr-icon
                        name="trash"
                        (click)="deleteCategory.emit(category.id)"
                        class="delete"
                    ></rr-icon>
                </div>
            </div>
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="category-description" i18n>
        <div class="more">
            <div class="tags">
                <div class="tags-row" *ngIf="category.tags">
                    <rr-badge
                        *ngFor="let tag of category.tags"
                        [icon]="tag.icon"
                        [tone]="getColorOfTag(tag)"
                        >{{ tag.name }}</rr-badge
                    >
                </div>
            </div>
        </div>
        <div>{{ category.description }}</div>
        <div
            class="sub-category-info"
            cdkDropList
            (cdkDropListDropped)="drop($event)"
        >
            Packages:
            <div *ngFor="let children of category.children" cdkDrag>
                <app-package-item
                    [category]="children"
                    [streams]="streams"
                    [streamOrder]="streamOrder"
                    (editPackage)="editCategory.emit(children)"
                    (deletePackage)="deleteCategory.emit(children.id)"
                ></app-package-item>
            </div>
        </div>
    </div>
</mat-expansion-panel>
